import React, { useCallback, useState } from 'react';

interface Props {
    text: string;
}

const TempMessage: React.FC<Props> = ({ text }) => {
    const [visible, setVisible] = useState(true);

    const hide = useCallback(() => {
        setVisible(false);
    }, []);

    return (
        <>
            {visible && (
                <div className="Toastify__toast Toastify__toast--info persistent-message">
                    <div role="alert" className="Toastify__toast-body">
                        {text}
                    </div>
                    <button
                        className="Toastify__close-button Toastify__close-button--info"
                        type="button"
                        aria-label="close"
                        onClick={hide}
                    >
                        ✖
                    </button>
                </div>
            )}
        </>
    );
};

export default TempMessage;
